import { Component } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { Icons, FeatureFlagService, LsqValidators } from '@lsq-frontend/common-ui';
import { FeatureFlags } from '@lsq-frontend/fasttrack-shared/app-constants';
import { LoginPageStep, LoginService } from '../login.service';

@Component({
    selector: 'forgot-password',
    styleUrls: ['./login-step.scss'],
    template: `
        <h1>Forgot Your Password?</h1>

        <form class="login-step" [formGroup]="formGroup" (ngSubmit)="sendForgotPasswordEmail()">
            <!-- TODO(PDEV-223): Remove label in favor of input's own label -->
            <p class="label" [style.marginBottom]="'-0.5rem'">Email Address</p>
            <lsq-input
                [style.marginBottom]="showEmailSentConfirmation ? '2rem' : '3rem'"
                name="emailAddress"
                type="email"
                [basicLabel]="false"
                formControlName="emailAddress"
                [group]="formGroup"
                [autoFocus]="true"
            >
            </lsq-input>

            <info-box
                *ngIf="showEmailSentConfirmation"
                [level]="'warning'"
                [icon]="icons.FaExclamationCircle"
                [style.marginBottom]="'2rem'"
                i18n
            >
                If a user with that email exists, a password reset email will be sent.
            </info-box>

            <lsq-button
                type="submit"
                size="block"
                [submitting]="isSubmitting"
                [disabled]="showEmailSentConfirmation"
                [style.marginBottom]="'2rem'"
            >
                Reset my password
            </lsq-button>

            <lsq-button appearance="transparent" size="block" (buttonClick)="backToLogin()">
                Go back
            </lsq-button>
        </form>
    `
})
export class ForgotPasswordComponent {
    public isSubmitting = false;
    public showEmailSentConfirmation = false;

    public readonly icons = Icons;
    public formGroup = this._formBuilder.group({
        emailAddress: ['', [Validators.required, LsqValidators.email]]
    });

    public forgotPasswordEnhancementIsOn$ = this._featureFlagService.isOn(
        FeatureFlags.ForgotPasswordEnhancement
    );

    constructor(
        private _formBuilder: FormBuilder,
        private _loginService: LoginService,
        private _featureFlagService: FeatureFlagService
    ) {}

    public async sendForgotPasswordEmail(): Promise<void> {
        this.formGroup.markAllAsTouched();

        if (this.formGroup.valid) {
            this.isSubmitting = true;

            if (this.forgotPasswordEnhancementIsOn$) {
                await this._loginService.sendEnterpriseForgotPasswordEmail(
                    this.formGroup.get('emailAddress').value
                );
            } else {
                await this._loginService.sendForgotPasswordEmail(
                    this.formGroup.get('emailAddress').value
                );
            }

            this.showEmailSentConfirmation = true;
        }
        this.isSubmitting = false;
    }

    public backToLogin(): void {
        this._loginService.setLoginPageStep(LoginPageStep.SignIn);
    }
}
